import cn from 'classnames';

import { ImageWithGallery } from '@webapp/common/components/image-with-gallery';
import { CssPageBlock } from '@webapp/common/components/survey-custom';
import { CDN_URL } from '@webapp/common/conf';
import { setHtml } from '@webapp/common/lib/ui';
import { QuestionParamsModelAbType } from '@webapp/common/resources/entities';

import type { QuestionAnswerContext } from '@webapp/survey/src/entities/answer-machine';

import css from './ab-testing.css';

export const ABTestingAnswer: VFC<{
    answer: QuestionAnswerContext;
    type: QuestionParamsModelAbType;
}> = ({ answer, type: propsType }) => {
    const { textBlock, file, value, videoLink } = answer;

    return (
        <div className={cn(CssPageBlock.ANSWER, css.answer, css[`answer_${propsType}`])}>
            {propsType === QuestionParamsModelAbType.TEXT && <div {...setHtml(textBlock)} />}
            {propsType === QuestionParamsModelAbType.IMAGE && (
                <ImageWithGallery
                    imageUrl={file?.path}
                    // todo удалить value[1]
                    textElem={<div {...setHtml(textBlock || value[1])} />}
                    alt='abTestImage'
                />
            )}
            {propsType === QuestionParamsModelAbType.VIDEO && (
                <>
                    {/* todo удалить value[1] */}
                    <div {...setHtml(textBlock || value[1])} />
                    {videoLink && (
                        <iframe
                            src={videoLink}
                            allowFullScreen={true}
                            allow='encrypted-media; fullscreen; picture-in-picture; clipboard-write; autoplay'
                        />
                    )}
                    {file?.path && (
                        <video
                            controls={true}
                            className={css.video}
                            src={CDN_URL + file?.path}
                            controlsList='nodownload'
                        >
                            Your browser does not support the video tag.
                        </video>
                    )}
                </>
            )}
        </div>
    );
};
ABTestingAnswer.displayName = 'ABTestingAnswer';
